/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.session.SessionStatus
*/
export var SessionStatus;
(function (SessionStatus) {
    SessionStatus["INIT"] = "INIT";
    SessionStatus["RUNNING"] = "RUNNING";
    SessionStatus["IDLE"] = "IDLE";
    SessionStatus["SUSPENDED"] = "SUSPENDED";
    SessionStatus["ARCHIVED"] = "ARCHIVED";
    SessionStatus["CLOSED"] = "CLOSED";
})(SessionStatus || (SessionStatus = {}));
//# sourceMappingURL=SessionStatus.js.map